import React from "react";
import "./Card.css";

function Card({
  cardTitle,
  cardDescription,
  cardLink,
  cardUrl,
  buttonText,
  cardClass,
}) {
  return (
    <div className={cardClass}>
      <img src={cardUrl} className="card-img" />
      <h4>{cardTitle}</h4>
      <p>{cardDescription}</p>

      {/* <Link to={cardLink} className="card-link">
        {buttonText}
      </Link> */}

      <a href={cardLink} className="card-link" target="_blank">
        {buttonText}
      </a>
    </div>
  );
}

export default Card;
